module.exports = __webpack_public_path__ + "static/media/shopping.6094a65a.png";